/**
 * Styled container for the slider right arrow element.
 * Positions the arrow at right 10px and top 337px for use when sliders are focused.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled container for the slider right arrow element.
 */
const SliderRightArrowContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
  -webkit-filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
  justify-content: center;
  opacity: 0.8;
  padding: ${Screen.widthRatio * 16}px;
  position: absolute;
  left: ${1839 * Screen.widthRatio}px;
  top: ${321 * Screen.widthRatio}px;
  &:hover {
    opacity: 1;
  }
`;

export default SliderRightArrowContainer;
